import type { PolarModel } from "../../../lib/stageViewModels";
import { Empty } from "./McqBars";
import { useGrowIn } from "./useGrowIn";

export function PolarDots({ model }: { model: PolarModel }) {
  const { grown, reduced, delay } = useGrowIn();
  if (model.total === 0) return <Empty />;
  return (
    <div className="grid grid-cols-2 gap-10 h-full text-rc-paper">
      {[model.a, model.b].map((side, i) => (
        <section key={side.key} className={`flex flex-col gap-5 ${i === 1 ? "items-end text-right" : ""}`}>
          <header>
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-rc-paper/55">{side.label}</div>
            <div className="font-bold tabular-nums tracking-[-0.03em] mt-1" style={{ fontSize: "clamp(2rem, 4vw, 3.6rem)" }}>{side.pct}% <span className="text-[14px] text-rc-paper/50 font-medium">{side.count} Stimmen</span></div>
          </header>
          <div className={`flex flex-wrap gap-3 ${i === 1 ? "justify-end" : ""}`} aria-label={`${side.label}: ${side.count} Personen`}>
            {Array.from({ length: side.count }).map((_, d) => (
              <span key={d} className={`w-6 h-6 rounded-full ${i === 0 ? "bg-rc-berry" : "bg-rc-paper"} ${reduced ? "" : "transition-[transform,opacity] duration-500 ease-out"}`} style={{ transform: grown ? "scale(1)" : "scale(0)", opacity: grown ? 1 : 0, transitionDelay: delay(d) }} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
